// import {
//   Component,
//   CUSTOM_ELEMENTS_SCHEMA,
//   ElementRef,
//   ViewChildren,
//   QueryList,
//   AfterViewInit,
//   PLATFORM_ID,
//   Inject,
// } from '@angular/core';
// import { CommonModule, isPlatformBrowser } from '@angular/common';

// // NOTE: 'register()' ab yahan module-level pe call nahi ho raha.
// // Woh customElements.define() use karta hai, jo sirf BROWSER mein hota hai.
// // SSR (server) pe yeh silently fail ho jaata tha, isliye <swiper-container>
// // ek plain unknown element ban jaata tha jiske paas .initialize() nahi hota.

// @Component({
//   selector: 'app-treatments',
//   standalone: true,
//   imports: [CommonModule],
//   templateUrl: './treatments.html',
//   styleUrl: './treatments.css',
//   schemas: [CUSTOM_ELEMENTS_SCHEMA],
// })
// export class Treatments implements AfterViewInit {
//   @ViewChildren('swiper')
//   swiperRefs!: QueryList<ElementRef>;

//   constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

//   ngAfterViewInit(): void {
//     // Server pe yeh poora block skip ho jayega
//     if (!isPlatformBrowser(this.platformId)) {
//       return;
//     }

//     // Sirf browser mein Swiper ko dynamically import + register karo
//     import('swiper/element/bundle').then(({ register }) => {
//       register();

//       this.swiperRefs.forEach((swiperRef, index) => {
//         const swiperEl = swiperRef.nativeElement;

//         Object.assign(swiperEl, {
//           loop: true,
//           speed: 1000,
//           spaceBetween: 20,

//           autoplay: {
//             delay: 3000,
//             disableOnInteraction: false,
//             pauseOnMouseEnter: true,
//           },

//           navigation: {
//             prevEl: `.custom-prev-${index}`,
//             nextEl: `.custom-next-${index}`,
//           },

//           pagination: false,

//           breakpoints: {
//             0: { slidesPerView: 1 },
//             576: { slidesPerView: 1 },
//             768: { slidesPerView: 2 },
//             992: { slidesPerView: 3 },
//             1200: { slidesPerView: 3 },
//           },
//         });

//         swiperEl.initialize();
//       });
//     });
//   }
// }
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  QueryList,
  ViewChildren,
  CUSTOM_ELEMENTS_SCHEMA,
  PLATFORM_ID,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-treatments',
  standalone: true,
  imports: [CommonModule, HttpClientModule],
  templateUrl: './treatments.html',
  styleUrl: './treatments.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  host: { ngSkipHydration: 'true' },
})
export class Treatments implements OnInit, AfterViewInit {
  @ViewChildren('swiper') swiperRefs!: QueryList<ElementRef>;

  categoryGroups: any[] = [];
  loading = true;
  errorMessage = '';
  imageBaseUrl = 'https://crm-api.redmonkwellness.com';
  apiUrl = 'https://crm-api.redmonkwellness.com/Treatment/GetTreatment';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    this.setSeo();
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.loadTreatments();
  }

  loadTreatments(): void {
    this.http.post<any>(this.apiUrl, {}).subscribe({
      // next: (res) => {
      //   if (res.success) {
      //     this.categoryGroups = this.groupByCategory(res.TreatmentHistory || []);
      //   } else {
      //     this.errorMessage = res.message || 'Unable to load treatments.';
      //   }
      //   this.loading = false;
      //   this.cdr.detectChanges(); // force render in case this ran outside Angular's zone
      //   // Initialize swipers after data is loaded and DOM is updated
      //   setTimeout(() => this.initSwipers(), 100);
      // },

      next: (res) => {
        if (res.success) {
          const activeList = (res.TreatmentHistory || []).filter(
            (t: any) => Number(t.IsActive) === 0 &&
             (t.TreatmentType || '').trim().toLowerCase() === 'procedure'
          );
          this.categoryGroups = this.groupByCategory(activeList);
        } else {
          this.errorMessage = res.message || 'Unable to load treatments.';
        }
        this.loading = false;
        this.cdr.detectChanges();

        setTimeout(() => this.initSwipers(), 100);
      },
      
      error: (err) => {
        console.error(err);
        this.errorMessage = 'Unable to load treatments. Please try again later.';
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  groupByCategory(list: any[]): any[] {
    const map = new Map<string, any[]>();
    for (const t of list) {
      const key = t.Category || 'Other';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(t);
    }
    return Array.from(map.entries()).map(([category, treatments]) => ({
      category,
      treatments,
      loop: treatments.length > 3,
    }));
  }

  trackById(_index: number, item: any): number {
    return item.ID;
  }

  // setDefaultImage(event: Event): void {
  //   const element = event.target as HTMLImageElement;
  //   element.src = '/assets/images/treatments/no-image.jpg';
  // }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Initialize swipers on first load if data is already present
    if (this.categoryGroups.length > 0) {
      setTimeout(() => this.initSwipers(), 100);
    }

    // Also watch for changes to ViewChildren
    this.swiperRefs.changes.subscribe(() => this.initSwipers());
  }
  
  private initSwipers(): void {
    import('swiper/element/bundle').then(({ register }) => {
      register();

      this.swiperRefs.forEach((swiperRef) => {
        const swiperEl: any = swiperRef.nativeElement;
        if (swiperEl.swiper) return;

        const shouldLoop = swiperEl.getAttribute('data-loop') === 'true';
        const catIndex = swiperEl.getAttribute('data-index');

        Object.assign(swiperEl, {
          loop: shouldLoop,
          speed: 1000,
          spaceBetween: 20,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            prevEl: `.custom-prev-${catIndex}`,
            nextEl: `.custom-next-${catIndex}`,
          },
          pagination: false,
          breakpoints: {
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 },
          },
        });

        swiperEl.initialize();
      });
    });
  }




private setSeo(): void {
  // =========================
  // PAGE SEO CONTENT
  // =========================

  const pageTitle =
    'Skin, Hair & Aesthetic Treatments in Mumbai | Red Monk Wellness';

  const description =
    'Explore skin, hair and aesthetic treatments in Mumbai at Red Monk Wellness, including HIFU, laser hair reduction, GFC, skin boosters, facials and hair treatments.';

  const keywords =
    'skin treatments Mumbai, hair treatments Mumbai, aesthetic treatments Mumbai, hair fall treatment Mumbai, skin booster Mumbai, facial treatment Mumbai, laser hair reduction Mumbai, HIFU treatment Mumbai, GFC hair treatment Mumbai, skin tightening treatment Mumbai, pigmentation treatment Mumbai, bridal skin treatment Mumbai, Red Monk Wellness';

  const canonicalUrl =
    'https://www.redmonkwellness.com/treatments';

  const ogImage =
    'https://www.redmonkwellness.com/assets/images/timelessmonk/hair-treatments/HAIR-REGROWTH-TRETMENT.jpg';

  // =========================
  // TITLE
  // =========================

  this.title.setTitle(pageTitle);

  // =========================
  // BASIC META TAGS
  // =========================

  this.meta.updateTag({
    name: 'description',
    content: description
  });

  this.meta.updateTag({
    name: 'keywords',
    content: keywords
  });

  this.meta.updateTag({
    name: 'robots',
    content:
      'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  });

  // Google Search Console verification
  this.meta.updateTag({
    name: 'google-site-verification',
    content: '7QzARYHwPFlrxb_DWbe2CdSeHLHRU-oTXeKHpi89MXg'
  });

  // =========================
  // OPEN GRAPH META TAGS
  // =========================

  this.meta.updateTag({
    property: 'og:type',
    content: 'website'
  });

  this.meta.updateTag({
    property: 'og:locale',
    content: 'en_IN'
  });

  this.meta.updateTag({
    property: 'og:site_name',
    content: 'Red Monk Wellness'
  });

  this.meta.updateTag({
    property: 'og:title',
    content: pageTitle
  });

  this.meta.updateTag({
    property: 'og:description',
    content: description
  });

  this.meta.updateTag({
    property: 'og:url',
    content: canonicalUrl
  });

  this.meta.updateTag({
    property: 'og:image',
    content: ogImage
  });

  // =========================
  // TWITTER / X META TAGS
  // =========================

  this.meta.updateTag({
    name: 'twitter:card',
    content: 'summary_large_image'
  });

  this.meta.updateTag({
    name: 'twitter:title',
    content: pageTitle
  });

  this.meta.updateTag({
    name: 'twitter:description',
    content: description
  });

  this.meta.updateTag({
    name: 'twitter:image',
    content: ogImage
  });

  // =========================
  // CANONICAL URL
  // =========================

  let canonical = this.document.querySelector(
    'link[rel="canonical"]'
  ) as HTMLLinkElement | null;

  if (!canonical) {
    canonical = this.document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    this.document.head.appendChild(canonical);
  }

  canonical.setAttribute('href', canonicalUrl);

  // =========================
  // SITEMAP LINK
  // =========================

  let sitemap = this.document.querySelector(
    'link[rel="sitemap"]'
  ) as HTMLLinkElement | null;

  if (!sitemap) {
    sitemap = this.document.createElement('link');
    sitemap.setAttribute('rel', 'sitemap');
    sitemap.setAttribute('type', 'application/xml');
    sitemap.setAttribute('title', 'Sitemap');
    this.document.head.appendChild(sitemap);
  }

  sitemap.setAttribute('href', '/sitemap.xml');
}


}